import React from "react";
import DashboardComponent from "../components/DashboardComponent";

function Dashboard() {
  return (
    <div>
      <DashboardComponent />
    </div>
  );
}

export default Dashboard;
